import React, { useEffect, useState } from "react";
import WebUtils from "../../utils/WebUtils";
import { createNewApi, getJdPreviewData } from "../../api/candidate";
import { notification, Tag } from "antd";
import PdfViewer from "../PdfViewer";
import {
  DownOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";

function JdCreationPreview({ userDetail, jdId, setLoading, setSteps }) {
  const [jdDetails, setJdDetails] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [pdfPages, setPdfPages] = useState(null);

  const getPreviewData = async () => {
    const url = `${getJdPreviewData}?jdIdentifier=${jdId}&userIdentifier=${userDetail?.userIdentifier}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setJdDetails(result.data.data);
        } else {
          setJdDetails(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const createNew = async () => {
    const url = `${createNewApi}?userIdentifier=${userDetail?.userIdentifier}&jdIdentifier=${jdId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          //   setJdDetails(result.data.data);
          //   console.log(result.data.data);
          notification.success({
            message: "Success",
            description: `${"Guide created successfully"}`,
            placement: "topRight",
            showProgress: true,
            duration: 2,
          });
          setTimeout(() => {
            window.location.href = "/preparation";
          }, 2000);
        } else {
          //   setJdDetails(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getPreviewData();
  }, []);

  const handleZoomIn = () => {
    setZoom(zoom + 0.2); // Increase zoom by 1.5 times
  };

  const handleZoomOut = () => {
    setZoom(zoom - 0.2); // Decrease zoom by 1.5 times
  };
  return (
    <div className=" m-auto  px-4 w-full md:flex-row flex-col flex items-start gap-4">
      <div className="border-2 rounded-lg px-5 py-6 md:w-[35%] w-full">
        <div className="flex items-start flex-col">
          <span className="text-[#101828] text-xl font-semibold">
            {jdDetails?.title}
          </span>
          <span className="text-gray-400 text-sm">
            {jdDetails?.jdIdentifier}
          </span>
          <span className="text-[#101828] font-medium mt-2">
            {jdDetails?.companyName}
          </span>
        </div>
        <div className="mt-3 text-[#475467] font-medium">
          <span>{jdDetails?.yearsOfExperience}+ years of experience</span>
        </div>
        <div className="mt-2 text-[#475467] font-medium">
          <span>Location: {jdDetails?.jobLocation}</span>
        </div>

        <div className="mt-3 flex items-center gap-x-1 gap-y-2 flex-wrap">
          {jdDetails?.tags?.map((tag, index) => (
            <Tag
              key={tag}
              className="px-2 "
              color="orange"
              style={{ borderRadius: "16px" }}
            >
              {tag}
            </Tag>
          ))}
        </div>
      </div>
      <div className="md:w-[65%] w-full">
        <div className="border-2 rounded-lg p-3">
          <div className="flex justify-between items-center">
            <p className="text-[#101828] font-semibold">Job description</p>
            <span
              className="  flex justify-end"
              style={{
                padding: "10px",
                position: "sticky",
                top: 0,
                zIndex: 1,
                right: 0,
                left: 0,
                background: "white",
              }}
            >
              <div className="">
                {/* <span className="mr-5 ml-0">pages:{pdfPages}</span> */}
                <button
                  onClick={handleZoomIn}
                  disabled={zoom > 1.8 ? true : false}
                  style={{
                    marginRight: "8px",
                    border: "none",
                    // borderRadius: "40%",
                    // background: "#f0f0f0",
                    // padding: "8px",
                  }}
                >
                  <PlusCircleOutlined
                    className={`${
                      zoom > 1.8 ? "text-[#848484]" : "text-[black]"
                    } text-[18px]`}
                    // style={{ fontSize: "18px", color: "#555555" }}
                  />
                  {/* {zoom * 100}% */}
                </button>
                <button
                  onClick={handleZoomOut}
                  disabled={zoom < 0.5 ? true : false}
                  style={{
                    border: "none",
                    // borderRadius: "40%",
                    // background: "#f0f0f0",
                    // padding: "8px",
                  }}
                >
                  <MinusCircleOutlined
                    className={`${
                      zoom < 0.5 ? "text-[#848484]" : "text-[black]"
                    } text-[18px]`}
                  />{" "}
                </button>
                <p
                  className="text-center ml-4 mr-0"
                  style={{
                    borderBottom: "1px solid black",
                    // borderRadius: "35%",
                    // background: "#f0f0f0",
                    // padding: "8px",
                    display: "inline-block",
                    width: "40px",
                  }}
                >
                  {Math.round(zoom * 100)}%
                </p>
              </div>
            </span>
          </div>

          <div className="w-full sm:h-[420px] h-[600px]  rounded-lg overflow-y-auto">
            {jdDetails?.jdUrl && (
              <PdfViewer
                url={jdDetails?.jdUrl}
                zoom={zoom}
                setPdfPages={setPdfPages}
              />
            )}
            {/* <iframe
              src={jdDetails?.jdUrl}
              title="PDF Preview"
              className="w-full h-full"
              style={{ border: "none" }}
            /> */}
          </div>
        </div>
        <div className="mt-3 flex justify-end mb-4 gap-3">
          <button
            className="driver-save-draft-button px-7 py-[0.4rem] btn-white text-sm"
            onClick={() => setSteps(1)}
          >
            Go Back
          </button>
          <button onClick={() => createNew()} className="btn-orange px-5 text-sm">
            Create Guide
          </button>
        </div>
      </div>
    </div>
  );
}

export default JdCreationPreview;
